<template>
  <el-dialog
    title="增加网点"
    v-model="dialogVisible"
    width="500px"
    @close="handleCancel"
  >
    <div class="dialog-content">
      <el-form :model="formData" label-position="top">
        <el-form-item label="物流公司" prop="companyId">
          <el-select
            v-model="formData.companyId"
            placeholder="请选择物流公司"
            @change="handleCompanyChange"
          >
            <el-option
              v-for="company in companyList"
              :key="company.company_id"
              :label="company.company_name"
              :value="company.company_id"
            />
          </el-select>
        </el-form-item>

        <el-form-item label="网点名称" prop="site">
          <el-input
            v-model="formData.site"
            placeholder="请输入网点名称"
          />
        </el-form-item>
      </el-form>
    </div>

    <template #footer>
      <el-button @click="handleCancel">取消</el-button>
      <el-button type="primary" @click="handleSubmit" :loading="submitting">
        {{ submitting ? '提交中...' : '确定' }}
      </el-button>
    </template>
  </el-dialog>
</template>

<script setup>
import { ref, reactive, watch, onMounted } from 'vue'
import { ElMessage } from 'element-plus'
import { postWlApi } from '@utils/api_v1.js'

const props = defineProps({
  visible: {
    type: Boolean,
    default: false
  }
})

const emit = defineEmits(['close', 'success'])

const formData = reactive({
  companyId: null,
  site: ''
})

const submitting = ref(false)
const dialogVisible = ref(props.visible)
const companyList = ref([])

// 监听visible属性变化，控制对话框显示
watch(() => props.visible, (newVal) => {
  dialogVisible.value = newVal
})

// 监听dialogVisible变化，当对话框关闭时触发close事件
watch(dialogVisible, (newVal) => {
  if (!newVal) {
    resetState()
    emit('close')
  }
})

// 获取物流公司列表
const fetchCompanyList = async () => {
  try {
    const response = await postWlApi('/get_companies')
    if (response.code === 0 && response.data?.companies) {
      companyList.value = response.data.companies
    }
  } catch (error) {
    console.error('获取物流公司列表失败:', error)
  }
}

// 处理公司选择变化
const handleCompanyChange = (companyId) => {
  formData.companyId = companyId
}

const resetState = () => {
  formData.companyId = null
  formData.site = ''
  submitting.value = false
}

const handleCancel = () => {
  dialogVisible.value = false
}

const handleSubmit = async () => {
  if (!formData.companyId) {
    ElMessage.error('请选择物流公司')
    return
  }

  submitting.value = true

  try {
    const requestData = {
      company_id: formData.companyId,
      site: formData.site.trim()
    }

    const response = await postWlApi('/create_access', requestData)

    if (response.code === 0) {
      ElMessage.success('Access创建成功')
      emit('success')
    } else {
      ElMessage.error(response.message || 'Access创建失败')
    }
  } catch (error) {
    console.error('创建Access失败:', error)
    ElMessage.error('Access创建失败')
  } finally {
    submitting.value = false
  }
}

// 组件挂载时获取公司列表
onMounted(() => {
  fetchCompanyList()
})
</script>

<style scoped>
.dialog-content {
  padding: 0;
}
</style>
